import { gql } from '@apollo/client';

export const GET_SEASON_COMPETITION_TEAMS = gql`
  query GetSeasonCompetitionTeams($seasonCompetitionId: ID) {
    getSeasonCompetitionTeams(seasonCompetitionId: $seasonCompetitionId) {
      seasonCompetition {
        id
        season {
          code
          displayName
        }
        competition {
          code
          displayName
        }
      }
      teams {
        id
        team {
          id
          nameShow
          shortName
          shield
          shieldPng
        }
      }
    }
  }
`;
